/**
 * @file コンポーネント：フル動画ページフル動画プレイヤー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { FullvideoPlayerButtonlist } from "~/src/components/projects/Video/FullvideoPlayerButtonlist";
import { FullvideoPlayerIconlist } from "~/src/components/projects/Video/FullvideoPlayerIconlist";
import { FullvideoPlayerSubtitle } from "~/src/components/projects/Video/FullvideoPlayerSubtitle";
import { Loading } from "~/src/components/uiparts/Loading";
import { Paragraph } from "~/src/components/uiparts/Paragraph";
import { RavnurPlayer } from "~/src/components/uiparts/RavnurPlayer";
//import { PlayerVideoJS } from "~/src/components/uiparts/PlayerVideoJS";

// 関数読み込み
import { fnIsAndroid, fnIsIpad, fnIsIphone } from "~/src/functions/boolean";

// スタイル読み込み
import {
    StyledFullvideo,
    StyledFullvideoContainer,
    StyledFullvideoLoading,
    StyledFullvideoMessage,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledFullvideo
            className={[props.isCompletionMediaPlayerFullvideo === false && "is-loading"]}
        >
            <StyledFullvideoContainer
                onMouseEnter={() => props.setIsHoverFullvideoContainer(true)}
                onMouseLeave={() => props.setIsHoverFullvideoContainer(false)}
                ref={props.refFullvideoPlayerContainer}
            >
                {/* ローディング */}
                {props.isCompletionMediaPlayerFullvideo === false && (
                    <StyledFullvideoLoading>
                        {/* サムネイル + ローディングを重ねて表示 */}
                        {props.thumbUrl ? (
                            <div style={{
                                width: "100%",
                                height: "100%",
                                background: "#000",
                                position: "relative"  // relative にするのがポイント
                            }}>
                                <img
                                    src={props.thumbUrl}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                                {/* サムネイル上に重ねる */}
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                }}>
                                    <Loading />
                                </div>
                            </div>
                        ) : (
                            // props.thumbUrl がまだ無効なとき
                            <Loading />
                        )}
                    </StyledFullvideoLoading>
                )}
                {props.fairplayCer !== null &&
                props.fairplayLaUrl !== null &&
                props.movieUrl !== null &&
                props.playreadyLaUrl !== null &&
                props.widevineLaUrl !== null && window.dataUser.isLogin === true ? (
                    // Media Playerが生成可能
                    <>
                        <RavnurPlayer
                            fairplayCer={props.fairplayCer}
                            fairplayLaUrl={props.fairplayLaUrl}
                            hasAudio={props.hasAudio}
                            mediaId="full"
                            movieUrl={props.movieUrl}
                            playreadyLaUrl={props.playreadyLaUrl}
                            setMediaPlayer={props.setMediaPlayerFullvideo}
                            widevineLaUrl={props.widevineLaUrl}
                            operationId={props.operationId}
                        />
                        {fnIsAndroid() === false &&
                            fnIsIpad() === false &&
                            fnIsIphone() === false && (
                                <>
                                    {/* アイコンリスト */}
                                    <FullvideoPlayerIconlist
                                        fnJump={props.fnJump}
                                        isHoverFullvideoContainer={
                                            props.isHoverFullvideoContainer
                                        }
                                        isPlayed={props.isPlayed}
                                        isShowIconComment={
                                            props.isShowIconComment
                                        }
                                        isShowIconEvent={props.isShowIconEvent}
                                        isShowIconTopic={props.isShowIconTopic}
                                        listComment={props.listComment}
                                        listEvent={props.listEvent}
                                        listTopic={props.listTopic}
                                        refFullvideoPlayerContainer={
                                            props.refFullvideoPlayerContainer
                                        }
                                        refFullvideoPlayerIconlist={
                                            props.refFullvideoPlayerIconlist
                                        }
                                    />
                                    {/* 字幕 */}
                                    <FullvideoPlayerSubtitle
                                        countSubtitlelist={
                                            props.countSubtitlelist
                                        }
                                        isLoadingFullvideo={
                                            props.isLoadingFullvideo
                                        }
                                        isShowSubtitle={props.isShowSubtitle}
                                        mainSurgeonId={props.mainSurgeonId}
                                        setSubtitlelist={props.setSubtitlelist}
                                        subtitlelist={props.subtitlelist}
                                    />
                                    {/* ボタンリスト */}
                                    <FullvideoPlayerButtonlist
                                        fnJump={props.fnJump}
                                        isEditPage={props.isEditPage}
                                        isShowIconChapter={
                                            props.isShowIconChapter
                                        }
                                        isShowIconComment={
                                            props.isShowIconComment
                                        }
                                        isShowIconEvent={props.isShowIconEvent}
                                        isShowIconTopic={props.isShowIconTopic}
                                        isShowSubtitle={props.isShowSubtitle}
                                        refFullvideoPlayerJumpButton={
                                            props.refFullvideoPlayerJumpButton
                                        }
                                        refFullvideoPlayerButtonlistSetting={
                                            props.refFullvideoPlayerButtonlistSetting
                                        }
                                        setIsShowIconChapter={
                                            props.setIsShowIconChapter
                                        }
                                        setIsShowIconComment={
                                            props.setIsShowIconComment
                                        }
                                        setIsShowIconEvent={
                                            props.setIsShowIconEvent
                                        }
                                        setIsShowIconTopic={
                                            props.setIsShowIconTopic
                                        }
                                        setIsShowSubtitle={
                                            props.setIsShowSubtitle
                                        }
                                        timeProgressSecond={
                                            props.timeProgressSecond
                                        }
                                        timeTotalSecond={props.timeTotalSecond}
                                    />
                                </>
                            )}
                    </>
                ) : window.dataUser.isLogin === false ? (
                    // 未ログイン状態の表示
                    <StyledFullvideoMessage>
                        <Paragraph
                            onColor="sub"
                            text={localized["ErrorMessage.LoginVideo"]}
                        />
                    </StyledFullvideoMessage>
                ) : (
                    // Media Playerが生成不可
                    <StyledFullvideoMessage>
                        <Paragraph
                            onColor="sub"
                            text={localized["ErrorMessage.FailLoadVideo"]}
                        />
                    </StyledFullvideoMessage>
                )}
            </StyledFullvideoContainer>
        </StyledFullvideo>
    );
};
